<template>
  <default-layout :class="['items-listing', {'items-listing--kanban': isKanban}]" unstick-header>
    <main-container size="full" no-top-padding>
      <div class="items-listing__header">
        <slot name="header-left" />
        <slot name="header-right" />
      </div>
      <div class="items-listing__main-header">
        <slot name="main-header" />
      </div>
      <div class="items-listing__body">
        <slot name="main-content" />
      </div>
      <slot name="modals" />
    </main-container>
  </default-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'

export default defineComponent({
  name: 'ItemsListingLayout',

  components: {
    MainContainer,
    DefaultLayout,
  },

  props: {
    isKanban: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.items-listing {
  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: -6px;
    z-index: 1031;
    background-color: var(--color-background-primary);
    padding: 16px 0 10px 0; // Adding normal top-padding of main-container here (and using no-top-padding) so the header "covers" the top when stickyness is enabled.
    margin-bottom: 18px;
    border-bottom: $border--dotted-light;
    min-height: 60px;

    @include media-breakpoint-down(md) {
      > :first-child {
        margin-bottom: 8px;
      }
    }

    @include media-breakpoint-up(lg) {
      /* Adjusts for the "new task/convo" button height on the __header area so the breadcrumb
         is identically positioned to "All tasks/convos" and task/convo detail. This is due to
         the <project/mailbox-home-header-options> pushing the height of the container up 4px. */
      margin-top: -4px;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__body {
    margin-top: 16px;
  }

  &--kanban {
    @include media-breakpoint-down(md) {
      overflow: hidden;
    }
  }
}
</style>
